"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var HandleRequest_1 = require("../services/requestHttp/HandleRequest");
var SearchAddressField = /** @class */ (function (_super) {
    __extends(SearchAddressField, _super);
    function SearchAddressField($view) {
        var _this = _super.call(this, $view) || this;
        _this.$input = _this.$view.find("input");
        _this.$suggestions = _this.$view.find(".dataList");
        _this.initListeners();
        return _this;
    }
    SearchAddressField.prototype.initListeners = function () {
        var _this = this;
        this.$input.on("keyup", 
        // @ts-ignore Typescript ne connait pas debounce() sur jQuery sur un pb dans les déclarations de types :(
        $.debounce(600, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.askSuggestions($(e.target))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }));
        this.$input.on("input", function (e) {
            if (_this.$view.find(".dataList option").filter(function () {
                return this.value === $(e.target).val();
            }).length) {
                var selectedValue = String($(e.target).val());
                var codePostal = "";
                var ville = "";
                var adresse = "";
                if (_this.startsWithNumber(selectedValue)) {
                    codePostal = selectedValue.match(/.*(\d{5})+/)[1];
                    ville = selectedValue.split(String(selectedValue.match(/.*(\d{5})+/)[1])).pop();
                    adresse = selectedValue.replace(String(codePostal), "").replace(ville, "");
                }
                else {
                    codePostal = selectedValue.match(/\d+/)[0];
                    ville = selectedValue.split(String(selectedValue.match(/\d+/))).pop();
                    adresse = selectedValue.replace(String(codePostal), "").replace(ville, "");
                }
                if (_this.$input.attr("id") === "main") {
                    var yAdresse = document.getElementById("address");
                    yAdresse.value = adresse;
                    var yCodePosal = document.getElementById("zip");
                    yCodePosal.value = String(codePostal);
                    var yVille = document.getElementById("city");
                    yVille.value = ville;
                }
                else {
                    var yAdresse = document.getElementById("construction_address");
                    yAdresse.value = adresse;
                    var yCodePosal = document.getElementById("construction_zip");
                    yCodePosal.value = String(codePostal);
                    var yVille = document.getElementById("construction_city");
                    yVille.value = ville;
                }
            }
        });
    };
    SearchAddressField.prototype.startsWithNumber = function (str) {
        return /^\d/.test(str);
    };
    SearchAddressField.prototype.askSuggestions = function ($el) {
        return __awaiter(this, void 0, void 0, function () {
            var url, address, dataRequest, response, data, dataRequest_1, response_1, data, dataRequest_2, response_2, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = $el.data("route");
                        address = $el.val().toString();
                        this.clearSuggestion();
                        if (!address) return [3 /*break*/, 9];
                        dataRequest = {
                            address: address,
                            type: $el.data("type"),
                        };
                        return [4 /*yield*/, (0, HandleRequest_1.send)(url, "POST", (0, HandleRequest_1.formDataFromObject)(dataRequest))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        this.loadResults(data.results);
                        return [3 /*break*/, 9];
                    case 3:
                        dataRequest_1 = {
                            address: address,
                            type: "street",
                        };
                        return [4 /*yield*/, (0, HandleRequest_1.send)(url, "POST", (0, HandleRequest_1.formDataFromObject)(dataRequest_1))];
                    case 4:
                        response_1 = _a.sent();
                        if (!response_1.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, response_1.json()];
                    case 5:
                        data = _a.sent();
                        this.loadResults(data.results);
                        return [3 /*break*/, 9];
                    case 6:
                        dataRequest_2 = {
                            address: address,
                            type: "municipality",
                        };
                        return [4 /*yield*/, (0, HandleRequest_1.send)(url, "POST", (0, HandleRequest_1.formDataFromObject)(dataRequest_2))];
                    case 7:
                        response_2 = _a.sent();
                        if (!response_2.ok) return [3 /*break*/, 9];
                        return [4 /*yield*/, response_2.json()];
                    case 8:
                        data = _a.sent();
                        this.loadResults(data.results);
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    SearchAddressField.prototype.loadResults = function (results) {
        if (results) {
            this.$suggestions.html(results);
        }
    };
    SearchAddressField.prototype.clearSuggestion = function () {
        this.$suggestions.empty();
    };
    return SearchAddressField;
}(BaseComponent_1.default));
exports.default = SearchAddressField;
